import React from 'react';
import { Helmet } from 'react-helmet';

const MetaTags = ({ title, description, image, url, type = 'website' }) => {
    // Ensure image URL is absolute (SSR-safe)
    const absoluteImageUrl = React.useMemo(() => {
        if (!image) return "";
        if (image.startsWith('http') || image.startsWith('//')) return image;
        if (image.startsWith('/')) {
            // SSR-safe: check if window exists before accessing
            const baseUrl = typeof window !== 'undefined'
                ? window.location.origin
                : process.env.VITE_SUPABASE_REDIRECT_URL || 'https://app.hyk.media';
            return `${baseUrl}${image}`;
        }
        return image;
    }, [image]);

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            
            {/* Open Graph Tags */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:image" content={absoluteImageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            {url && <meta property="og:url" content={url} />}
            <meta property="og:site_name" content="HYK Media" />
            
            {/* Twitter Card Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={absoluteImageUrl} />
            
            {/* Canonical URL */}
            {url && <link rel="canonical" href={url} />}
        </Helmet>
    );
};

export default MetaTags;